module.exports = __webpack_public_path__ + "img/nicehotel.1a6bbd46.jpg";